import { render, staticRenderFns } from "./VersionControl.vue?vue&type=template&id=7c78f70c&scoped=true&"
import script from "./VersionControl.vue?vue&type=script&lang=ts&"
export * from "./VersionControl.vue?vue&type=script&lang=ts&"
import style0 from "./VersionControl.vue?vue&type=style&index=0&id=7c78f70c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c78f70c",
  null
  
)

export default component.exports